<script lang="ts">
  //WIP: look at the dataset search and fill in the cards like the ones on there.
  // I think we are going to have to figure out how to pass in a variable from the hugo side
  //the hugo file associated with this is term.html.html

  import type {DatasetSearchResultsModel} from "./models/dataset.interface";
  import {SearchState} from "./services/search-service";

  const PAGE_SIZE = 12;
  const searchEndpoint = new URL(process.env.SEARCH_URL);

  let collectionSearchInput: string;

  let datasetsLoaded: Promise<DatasetSearchResultsModel>;

  SearchState.subscribe(search => {
    search.params.set("limit", PAGE_SIZE.toString());
    search.params.set("offset", ((search.pageNum - 1) * PAGE_SIZE).toString());

    datasetsLoaded = fetchPubs(search.params);
  });

  async function fetchPubs(params: URLSearchParams): Promise<DatasetSearchResultsModel> {
    const response = await fetch(`${searchEndpoint}/v2/publications/${'dunno'}?${params}`);
    if (!response.ok) throw new Error("Failed to fetch publications");

    return await response.json();
  }
</script>

<div class="container-fluid">
  <div class="row">
    <main class="col-md">
      <section id="dataset-results">
        <!-- search bar -->
        <div class="row">
          <div class="p-5 mb-4 collection">
            <div class="d-flex justify-content-center mt-3">
              <div class="w-50 shadow-sm">
                <input class="form-control form-control-lg text-center nosubmit" id="searchFloatingInput"
                       placeholder="Search though topic"
                       type="text">
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="d-flex justify-content-center mt-2">
            <div class="badge shadow-sm"
                 style="--bs-btn-border-radius: 200px; width: 20em; --bs-btn-font-weight: bold; background-color: #007EC6">
              collections found
            </div>
          </div>
        </div>

        <div class="row mt-2 mb-2"></div>

        <!-- dataset cards -->
        <div class="row row-cols-1 row-cols-md-2 row-cols-lg-4">
          <div class="col mb-3">
            <div class="card h-100">
              <div class="card-body">
                <h5 class="card-title">name</h5>
                <li style="list-style-type: none">
                  <h7 class="card-subtitle mb-2 text-muted">name</h7>
                </li>
                <li style="list-style-type: none">
                  <h7 class="card-subtitle mb-2 text-muted">
                    <time datetime="2020-09-30T12:00:00+01:00"> date to date</time>
                  </h7>
                </li>
                <div class="text-truncate-container">
                  <p class="card-text pt-1">description</p>
                </div>
              </div>
              <div class="card-footer">
                <div class="row align-items-center">
                  <div class="col text-muted">Keyword Tags</div>
                  <div class="col-md-auto">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  </div>

  <!-- pagination -->
  <div class="row">
    <div class="col">
    </div>
  </div>
</div>

<style>
  /* Cards */
  .text-truncate-container {
    height: auto;
  }

  .text-truncate-container p {
    -webkit-line-clamp: 6;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .card .card-body .card-title .text-truncate-container {
    box-sizing: border-box;
    font-family: sans-serif;
  }

  .card-title {
    font-family: Arial;
  }

  .card {
    transition: all 0.25s ease;
    box-shadow: 0 0 1rem rgba(0, 0, 0, .15);
  }

  .card:hover {
    box-shadow: 0 0 1.5rem rgba(0, 0, 0, .3);
  }

  /*div>i {*/
  /*    background-color: transparent;*/
  /*    font-size: 1.3rem;*/
  /*}*/
</style>
